import { EventBus } from '@johnlewispartnership/wtr-website-eventbus';

export const HEADER_EVENTS_CHANNEL = 'wtr-events.header';
export const OPEN_MOBILE_OVERLAY_WINDOW_EVENT = 'OPEN_MOBILE_OVERLAY_EVENT';
export const OPEN_MOBILE_OVERLAY_WINDOW_CLEAR_EVENT = 'OPEN_MOBILE_OVERLAY_CLEAR_EVENT';

const HeaderEventBus = new EventBus(HEADER_EVENTS_CHANNEL);
export default HeaderEventBus;
